import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import Button from "@mui/material/Button";
import { PlaceOrderCTAContainer } from "./PlaceOrderCTA.style";
import { Link } from "react-router-dom";
import styled from "styled-components";

const PlaceOrderCTANew = () => {

   
  const CheckoutButton = styled.button`
  display: flex;
  flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color:rgb(72, 72, 72);
    color: white;
    border: none;
    outline: none;
    padding: 10px 20px;
    color: white;
    font-size: .8rem;
    cursor: pointer;

    margin-left:auto;
  `  
    
  return (
    
   <Link to="/checkout" >
     <CheckoutButton >
        Proceed to Checkout
    </CheckoutButton>
   </Link>
  );
};

export default PlaceOrderCTANew;
